// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RefreshCreatorImageButton {
  padding: 0;
}
.RefreshCreatorImageButton img {
  border: 1px solid var(--color_neutral_0) !important;
  border-radius: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/RefreshCreatorImageButton/index.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;AACF;AACE;EACE,mDAAA;EACA,mBAAA;AACJ","sourcesContent":[".RefreshCreatorImageButton {\n  padding: 0;\n\n  img {\n    border: 1px solid var(--color_neutral_0) !important;\n    border-radius: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
